<template>
    <section v-bind:class="[!visible ? 'hidden' : '']" class="section policy-container">
        <div class="container">
            <div class="row">
                <h2 class="col-10 col-xs-11">
                    {{ policyTitle }}
                </h2>
                <a v-on:click="onClickClose" href="#" class="close-policy col-2 col-xs-1"></a>
                <div class="col-12">
                    <div v-html="policy">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Policy",
    props: ["visible", "type"],
    computed: {
        policyTitle() {
            if (this.type === "policy") {
                return this.$store.state.policyTitle;
            } else {
                return this.$store.state.shipRecyclingTitle;
            }
        },
        policy() {
            if (this.type === "policy") {
                return this.$store.state.policy;
            } else {
                return this.$store.state.shipRecycling;
            }
        }
    },
    methods: {
        onClickClose(ev) {
            if (this.type === "policy") {
                this.$emit('togglePolicy', ev);
            } else {
                this.$emit('toggleShipRecycling', ev);
            }
        }
    }
}
</script>

<style scoped>
.policy-container {
    height: 75vh;
    overflow: auto;
    background-color: #0A2739;
    color: #FFF;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: absolute;
    bottom: 0;
    z-index: 1002;
    width: 100%;
    position: fixed;
}

.policy-container::-webkit-scrollbar {
    display: none;
}

.policy-container.hidden {
    display: none;
}

.policy-container h2 {
    font-size: 1.5em;
    font-weight: 400;
}

.policy-container h3 {
    font-size: 1em;
    margin: 1.5em auto;
    line-height: 1.5em;
}

.policy-container a.close-policy:after {
    font-family: "FontAwesome";
    content: "\f00d";
    position: absolute;
    font-size: 1.5em;
    right: 1em;
    top: 0em;
    color: #FFF;
}

@media only screen and (min-width: 576px) {
    .policy-container h2 {
        font-size: 2em;
        margin-bottom: 1.5em;
    }

    .policy-container h3 {
        font-size: 1.4em;
        margin: 1.2em auto;
        line-height: 1.2em;
    }

    .policy-container a.close-policy:after {
        font-size: 2em;
    }
}

@media only screen and (min-width: 992px) {
    .policy-container {
        height: 500px;
    }

    .policy-container h2 {
        font-size: 2.5em;
    }

    .policy-container h3 {
        font-size: 1.8em;
    }
}
</style>